export const WRONG_IMAGE_TYPE_ERROR = 'WRONG_IMAGE_TYPE_ERROR'
export const IMAGE_FILE_TOO_LARGE = 'IMAGE_FILE_TOO_LARGE'
export const FAILED_TO_UPLOAD_ERROR = 'FAILED_TO_UPLOAD_ERROR'
export const FAILED_TO_DELETE_ERROR = 'FAILED_TO_DELETE_ERROR'
export const OUTAGE_OFFER_ERROR = 400123
